// PRD-65 — the text caps of a per-student content edit. Mirrors
// apps/backend/core/constants.py::MaterialEditConfig (`stem_max_length`,
// `option_max_length`); the API is the one that refuses, these let the
// editor say so next to the field before the professor saves.
// PRD-69 — who prepared a material. Mirrors
// apps/backend/core/models.py::Material.Origin. A professor only ever
// receives a `staff` material once Platonica sent it.
export const MATERIAL_ORIGIN = {
  professor: "professor",
  staff: "staff",
} as const
export type MaterialOrigin = (typeof MATERIAL_ORIGIN)[keyof typeof MATERIAL_ORIGIN]

export const MATERIAL_EDIT_LIMITS = {
  stemMaxLength: 2000,
  optionMaxLength: 500,
} as const
